import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OrderbookStateT, OrderbookT } from 'types';

export const initialOrderbookState: OrderbookStateT = {
  orderbook: {
    buy: [],
    sell: [],
  },
};

const orderbookSlice = createSlice({
  name: 'orderbook',
  initialState: initialOrderbookState,
  reducers: {
    setOrderbook(state, action: PayloadAction<OrderbookT>) {
      state.orderbook = action.payload;
    },
  },
});

export const { setOrderbook } = orderbookSlice.actions;

export default orderbookSlice.reducer;
